export const ReactData = [
  {
    title: "CodingColab / SyncCode",

    desc: "Real-time collaborative coding platform with synchronized code editing, video sharing, whiteboarding, secure code execution, and authentication.",

    tech: [
      "React",
      "Socket.IO",
      "WebRTC",
      "Yjs / CRDTs",
      "Supabase",
      "Redis",
      "Piston API"
    ],

    gitlink: "https://github.com/manno198/CodingColab",

    category: "fullstack"
  },

  {
    title: "GPTLens",

    desc: "AI-powered ChatGPT productivity extension for smarter conversation navigation",

    tech: [
      "JavaScript",
      "Chrome Extension",
      "Manifest V3",
      "AI Summarization",
      "DOM Parsing",
      "Chrome Storage"
    ],

    gitlink: "//github.com/manno198/GPTLens",

    category: "ai-ml"
  },

  {
    title: "K's Restaurant",

    desc: "Real-time food ordering platform with live order-status updates, admin notification system, and RBAC.",

    tech: ["React", "Node.js", "TypeScript", "Supabase", "CSS"],

    site: "https://krestaurant-zeta.vercel.app/",

    category: "react"
  },

  {
    title: "BrainyTree",

    desc: "AI-powered brain tumor classification platform using a fine-tuned SigLIP vision model",

    tech: [
      "Python",
      "PyTorch",
      "Hugging Face Transformers",
      "SigLIP",
      "FastAPI",
      "React",
      "TypeScript"
    ],

    gitlink: "//github.com/manno198/BrainyTree",

    site: "//brainytree.vercel.app/",

    category: "ai-ml"
  },

  {
    title: "TrackUrTask",

    desc: "Full-stack employee task tracking platform with JWT authentication, REST APIs, PostgreSQL, and AWS deployment.",

    tech: [
      "React",
      "Vite",
      "Node.js",
      "Express.js",
      "PostgreSQL",
      "JWT",
      "AWS S3",
      "AWS EC2",
      "AWS RDS"
    ],

    gitlink: "https://github.com/manno198/TrackUrTask",

    site: "http://trackurtask-frontend-903797724213.s3-website.ap-south-1.amazonaws.com/",

    category: "fullstack"
  },

  {

   title: "LiberLightPDF",

    desc: "Feature-rich browser-based PDF editor with annotations, per-page notes, and editable PDF export.",

    tech: [
        "React",
        "TypeScript",
        "Vite",
        "PDF.js",
        "jsPDF",
        "Tailwind CSS",
        "shadcn/ui"
    ],
    gitlink: "https://github.com/manno198/LiberLightPDF",

    site: "https://liberlightpdfeditor.netlify.app/",

    category: "fullstack"
  },

  {
    title: "Q/A SQL Chat",

    desc: "AI-powered natural language interface for querying SQL databases",

    tech: ["Python", "LangChain", "ChatGroq", "MySQL"],

    gitlink: "https://github.com/manno198/Q-A-SQL",

    category: "ai-ml"
  },

  // {
  //   title: "Pedestrian Identification",

  //   desc: "ML-based traffic safety and pedestrian detection system",

  //   tech: ["Machine Learning", "Python", "Computer Vision"],

  //   gitlink: "//github.com/manno198/Pedestrian-Identification-for-Excellence-Driving-System-PIEDS",

  //   category: "ai-ml"
  // },

  // {
  //   title: "Price Prediction",

  //   desc: "Crop price prediction using machine learning and time-series analysis",

  //   tech: ["Machine Learning", "Python", "SARIMA"],

  //   gitlink: "//github.com/manno198/price_prediction",

  //   category: "ai-ml"
  // },

  // {
  //   title: "Hostelies",

  //   desc: "Hostel management web application for managing rooms and residents",

  //   tech: ["React", "PHP", "Tailwind CSS"],

  //   gitlink: "//github.com/manno198/Hostelies",

  //   category: "fullstack"
  // },


  // {
  //   title: "UrOwnFarm",

  //   desc: "Frontend-focused farm management web application",

  //   tech: ["JavaScript", "HTML", "CSS"],

  //   gitlink: "//github.com/manno198/UrOwnFarm",

  //   category: "fullstack"
  // },

  // {
  //   title: "Fitness Tracker",

  //   desc: "Web-based fitness tracking application",

  //   tech: ["JavaScript","JWT Authentication", "HTML", "CSS"],

  //   gitlink: "//github.com/manno198/Fitness-Tracker",

  //   category: "fullstack"
  // }

  // ===== UI / UX =====
  // (Add UI/UX-only projects here later)
];